import interceptor from '@/plugins/interceptor';
const preInscriptionPath = '/primera-entrevista';

export default {
    state: () => ({}),
    mutations: { 
    },
    actions: {
        async inscription_postPreInscription(_,model) {
            return await interceptor.anonymous.post(`${process.env.VUE_APP_API_URL}${preInscriptionPath}/register`,model);
        },

        async inscription_getPaises() {
            return await interceptor.anonymous.get(`${process.env.VUE_APP_API_URL}${preInscriptionPath}/paises`);
        },

        async inscription_getOptions() {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_URL}${preInscriptionPath}/certificado-opciones`);
        },
        

        async course_progress_get() {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_URL}${preInscriptionPath}/course-progress`);
        }, 

        async course_progress_save(_,model) {
            return await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${preInscriptionPath}/course-progress`,model);
        }, 

        async course_certificate_download() {
            return await interceptor.authenticate.getFile(`${process.env.VUE_APP_API_URL}${preInscriptionPath}/certificate`,"certificado.pdf");
        }, 

        async certificate_completeData(_,model) {
            return await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${preInscriptionPath}/certificate-data`,model);
        }, 

        async inscription_changePassword(_,model) {
            return await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${preInscriptionPath}/update-password`,model);
        }, 
        
        


        async inscription_getPreInscription(_,id) {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_URL}${preInscriptionPath}`,id);
        },
        
        
        async preInscription_getPreInscriptionStage(_, params) {
            const { preInscriptionId, stage=0 } = params
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_URL}${preInscriptionPath}/${preInscriptionId}/settings?stage=${stage}`);
        },
        async preInscription_postPreInscriptionStage(_, req) {
            return await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${preInscriptionPath}/${req.preInscriptionId}/students`, req);
        },
        async preInscription_studentCheck(_, params) {
            const { preInscriptionId } = params
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_URL}${preInscriptionPath}/${preInscriptionId}/students?${params.GUID ? 'studentIdentifier=' + params.GUID : 'studentEmail=' + params.email}`);
        }
    }
}
